import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { serviceAreas } from "../data/serviceAreas";

export const Contact = (props) => {
  const emailAddress = props.data?.email?.trim();
  const featuredServiceAreas = serviceAreas.slice(0, 6);
  const socialLinks = [
    {
      href: props.data?.facebook,
      iconClass: "fa fa-facebook",
      label: "Hamilton Pressure Washing on Facebook",
    },
    {
      href: props.data?.google,
      iconClass: "fa fa-google",
      label: "Hamilton Pressure Washing on Google",
    },
    {
      href: props.data?.instagram || props.data?.youtube,
      iconClass: "fa fa-instagram",
      label: "Hamilton Pressure Washing on Instagram",
    },
  ].filter((entry) => entry.href);

  useEffect(() => {
    // Add the CSS file
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://d3ey4dbjkt2f6s.cloudfront.net/assets/external/work_request_embed.css";
    link.media = "screen";
    document.head.appendChild(link);

    // Add the script file
    const script = document.createElement("script");
    script.src = "https://d3ey4dbjkt2f6s.cloudfront.net/assets/static_link/work_request_embed_snippet.js";
    script.setAttribute("clienthub_id", "b95a7c63-d934-4d94-b5d7-1918829b4e80");
    script.setAttribute(
      "form_url",
      "https://clienthub.getjobber.com/client_hubs/b95a7c63-d934-4d94-b5d7-1918829b4e80/public/work_request/embedded_work_request_form"
    );
    document.body.appendChild(script);

    return () => {
      // Clean up: remove the script and link when the component unmounts
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h1>Request A Free Pressure Washing Quote In Clinton, NC</h1>
                <p>
                  Please fill out the form below to request a free quote.
                </p>
              </div>
            </div>
            {/* Embed Jobber's form */}
            <div id="b95a7c63-d934-4d94-b5d7-1918829b4e80"></div>
          </div>
          
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {emailAddress ? (
                  <a className="contact-link" href={`mailto:${emailAddress}`}>
                    {emailAddress}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  {socialLinks.map((socialLink) => (
                    <li key={socialLink.label}>
                      <a
                        href={socialLink.href}
                        target="_blank"
                        rel="noopener noreferrer nofollow external"
                        aria-label={socialLink.label}
                        title={socialLink.label}
                      >
                        <i className={socialLink.iconClass}></i>
                        <span className="sr-only">{socialLink.label}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-12 contact-location-links-wrap">
            <h3 className="contact-location-heading">Serving Clinton And Nearby Areas</h3>
            <p className="contact-location-copy">
              Looking for pressure washing near Clinton, NC? We also serve nearby towns across
              Sampson County and surrounding communities.
            </p>
            <div className="contact-location-links">
              {featuredServiceAreas.map((serviceArea) => (
                <Link key={serviceArea.slug} to={`/service-areas/${serviceArea.slug}`}>
                  Pressure Washing {serviceArea.city}, {serviceArea.state}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 Hamilton Pressure Washing. Design by{" "}
            <a href="https://www.linkedin.com/in/zacharyslucas/" rel="nofollow">
              Zachary Lucas
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
